import { React, Table } from '@1337lawyers/design';

export const PendingVerificationRequests = () => (
  <Table headers={['Issuer', 'Investor', 'Requested', 'Status']} data={[]} />
);
